<h3 class="search-header">
  {{'Свеобухватна претрага' | translit}}
  <mat-icon class="close-button"
    (click)="onClose()">close</mat-icon>
</h3>

<div class="filter-button-div">
  <span class="filter-label">{{'Укључи у претрагу' | translit}}:</span>
  <button mat-icon-button
    class="filter-btn"
    [class.active]="filterCities()"
    [matTooltip]="'Градови' | translit"
    (click)="toggleFilter(filterCities)">
    <mat-icon>location_city</mat-icon>
  </button>
  <button mat-icon-button
    class="filter-btn"
    [class.active]="filterTags()"
    [matTooltip]="'Тагови' | translit"
    (click)="toggleFilter(filterTags)">
    <mat-icon>label</mat-icon>
  </button>
  <button mat-icon-button
    class="filter-btn"
    [class.active]="filterNames()"
    [matTooltip]="'Имена и презимена' | translit"
    (click)="toggleNamesAndSurnames()">
    <mat-icon>people</mat-icon>
  </button>
  <button mat-icon-button
    class="filter-btn"
    [class.active]="filterInstagram()"
    [matTooltip]="'Инстаграм' | translit"
    (click)="toggleFilter(filterInstagram)">
    <mat-icon>camera_alt</mat-icon>
  </button>
</div>


@if (recentSearches.length) {
<div class="recent-searches">
  @for (recent of recentSearches; track recent) {
  <img [src]="recent.imagePath"
    (click)="onItem(recent)"
    class="recent-image"
    [class.missing-image]="!recent.imagePath"
    loading="lazy"
    [alt]="recent.commonName"
    appDefaultLogo>
  }
</div>
}

<form class="search-form">
  <mat-form-field class="search-field"
    appearance="outline">

    <!-- Field Label -->
    <mat-label class="search-label">{{'Претрага' | translit}}</mat-label>

    <!-- Search Input -->
    <input matInput
      #searchInput
      class="search-input"
      [matAutocomplete]="auto"
      (keydown.enter)="$event.preventDefault()"
      [formControl]="control">

    <!-- Autocomplete dropdown -->
    <mat-autocomplete #auto="matAutocomplete"
      autoActiveFirstOption>
      @for (group of (filteredItems$ | async); track group.label) {
      <mat-optgroup [label]="group.label | translit">
        @for (item of group.items; track item.slug) {
        <mat-option class="autocomplete-option"
          (onSelectionChange)="onItem(item)"
          [value]="item.name">
          @if (item.isTag) {
          <mat-icon class="item-tag-icon">label</mat-icon>
          } @else {
          <img [alt]="item.name | translit"
            appDefaultLogo
            [class.item-image--instagram]="item.isInstagram"
            class="item-image"
            [src]="item.isInstagram ? 'assets/images/Instagram_icon.png' : item.imagePath">
          }
          <span>
            <div class="item-name">
              {{item.commonName | translit}}
            </div>
            @if (!item.title && !item.isFirstName && !item.isTag && !item.isInstagram) {
            <div>
              <small>
                {{item.fullTitle | translit}}
                @if (item.birthDeath) {
                <span>
                  ({{item.birthDeath | translit}})
                </span>
                }
              </small>
            </div>
            }
          </span>
        </mat-option>
        }
      </mat-optgroup>
      }
    </mat-autocomplete>
  </mat-form-field>

  <!-- hint -->
  @if (showThreeLetterWarning) {
  <div class="warning-message info">
    * {{'Минимум три слова потребна' | translit}}
  </div>
  }
  @if (showNoResultWarning) {
  <div class="warning-message">
    * {{'Нема резултата који одговарају претрази.' | translit}}
  </div>
  }
</form>